export default "__VITE_ASSET__B$q8MB5O__"